import React from 'react'
import { Image } from 'react-bootstrap';
import "../../assets/css/scss/component/_aboutInfoCard.scss"
import { useSelector } from 'react-redux';
import { IReduxStateData } from '../../interfaces/redux';
import { ABOUT_US_SHORT_TITLE, ABOUT_US_SORT_DESCRIPTION } from '../../constant/menuAndProfile';

export default function AboutInfoCard() {
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLanguage = globalState?.selectedLang;
    return (
        <div className="about-us align-items-center align-items-md-start theme-dark-gray h-100 d-flex flex-wrap flex-column flex-sm-nowrap flex-sm-row flex-md-column flex-md-wrap">
            <div>
                <h3 className="theme-green bold mb-2 mb-xl-4" dangerouslySetInnerHTML={{ __html: ABOUT_US_SHORT_TITLE[selectedLanguage] }} />
                <p className="font-13 theme-white" dangerouslySetInnerHTML={{ __html: ABOUT_US_SORT_DESCRIPTION[selectedLanguage] }} />
            </div>
            <Image src="/assets/images/about.jpg" className="w-100 mt-md-auto" alt="about" fluid />
        </div>
    )
}
